import { Box, Typography } from '@mui/material';
import '../styles/SectionB.scss';
import { useAppSelector } from '../../../../../../app/redux/hooks';

const SectionB = () => {
  const themes = useAppSelector(state => state.theme.theme);

  const constants = {
    content: `From fleet managers seeking to streamline operations to business owners safeguarding valuable resources,${
      themes == 'ayka' ? 'Ayka' : 'Yaantrac'
    } is the solution of choice. Backed by advanced analytics and round-the-clock support, we're committed to helping you stay ahead in an ever-evolving landscape. Experience the future of vehicle management with ${
      themes == 'ayka' ? 'Ayka' : 'Yaantrac'
    } - where precision meets simplicity. ${
      themes == 'ayka' ? 'Ayka' : 'Yaantrac'
    }'s overarching goal is to empower vehicle owners by offering centralized monitoring capabilities for all their vehicles and associated trips. This centralized approach enables users to conveniently oversee their entire fleet from a single, accessible location, thereby streamlining operations and enhancing efficiency.`
  };

  return (
    <Box className='section-b' my={2}>
      <Typography component='h6'>{constants.content}</Typography>
    </Box>
  );
};

export default SectionB;
